import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { IUserGroup, userGroupsActions } from '../../../redux/userGroups/userGroupsSlice';
import AddRemoveMemberModal from '../AddRemoveMemberModal';
import { useAppSelector } from '../../../redux/hooks';

function AddRemoveMembersCell({ row }: { row: IUserGroup }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const { addRemoveMembersSuccess } = useAppSelector((state) => state.userGroups);

  useEffect(() => {
    if (addRemoveMembersSuccess) {
      setOpen(false);
      dispatch(userGroupsActions.resetAddRemoveMembersSuccess());
    }
  }, [addRemoveMembersSuccess]);

  return (
    <Grid container justifyContent="space-between" width={111}>
      <Typography variant="bodyRegular" color="primary" pr={3}>
        {row.clients.length + row.coaches.length}
      </Typography>
      <img
        src="/assets/icons/plus-minus.svg"
        alt="img"
        role="presentation"
        style={{ cursor: 'pointer' }}
        onClick={() => setOpen(true)}
      />
      <AddRemoveMemberModal
        isOpen={open}
        handleDismiss={() => setOpen(false)}
        userGroupId={row.id}
        name={row.name}
      />
    </Grid>
  );
}

export default AddRemoveMembersCell;
